@if (entry.base?.display) {
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath" class="event-form">
    <!--Date of Life Event-->
    <mat-form-field appearance="outline" class="event-date">
      <mat-label>{{entry?.formControlAttributes?.label}}</mat-label>
      <!-- @TODO Add constraints & messaging to detail the windows of validity -->
      <input matInput [matDatepicker]="picker1" [formControlName]="entry?.formControlAttributes?.formControlName" placeholder="MM/DD/YYYY" (dateChange)="dateChanged('change', $event)">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      @if (formControls[entry?.formControlAttributes?.formControlName]?.errors?.required) {
        <mat-error>{{entry.custom?.dateOfLifeEventRequiredErrorMessage || 'Required'}}</mat-error>
      }
      @if (formControls[(entry?.formControlAttributes?.formControlName)]?.errors?.firstOfMonth) {
        <mat-error>{{ custom?.firstOfMonthErrorMessage ? custom.firstOfMonthErrorMessage : "Dates must be the first of the month." }}</mat-error>
      }
      @if (formControls[(entry?.formControlAttributes?.formControlName)]?.errors?.outOfRange) {
        <mat-error>{{ custom?.dateOfLifeEventRangeErrorMessage ? custom.dateOfLifeEventRangeErrorMessage : "Date is out of range" }}</mat-error>
      }
    </mat-form-field>
  </form>
}